import React from "react";

// reactstrap
import { 
  Col, 
  Badge 
} from "reactstrap";

// fontawesome icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBriefcase,
  faGraduationCap,
  faExternalLinkAlt,
} from "@fortawesome/free-solid-svg-icons";

// file (resume)
import file_resume from "../../../public/files/MarkGalisa_Resume.pdf";

// components
import SiteLink from "../../../components/SiteLink";

function Experience ({works}) {
  const Education = () => {
    return (
      <>
        <h3>
          <FontAwesomeIcon icon={faGraduationCap} /> Education
        </h3>
        <SiteLink siteLink="https://perpetualdalta.edu.ph/" siteName="University of Perpetual Help Systems Dalta" />
        <span className="d-block">Las Piñas, Metro Manila</span>
        <span className="d-block">Class of 2016</span>
        <span className="d-block mt-4">Degree: Bachelor of Science in I.T.</span>
      </>
    )
  }

  const Work = () => {
    return (
      <div className="mt-5">
        <h3>
          <FontAwesomeIcon icon={faBriefcase} /> Work Experience
        </h3>
        {
          works.map((work, idx) => {
            return (
              <div className="skills-work-list mb-4" key={idx}>
                <SiteLink siteLink={work.companyLink} siteName={work.companyName} />
                <span className="d-block">
                  <Badge className="secondary-color">{work.workDateStart + " to " + work.workDateEnd}</Badge>
                </span>
                <span className="d-block">{work.position}</span>
              </div>
            );
          })
        }
        <a
          className="btn btn-dark rounded-0 projects-btn"
          href={file_resume}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon className="mr-2" icon={faExternalLinkAlt} />
          View my resume
        </a>
      </div>
    );
  }

  return (
    <Col lg={{ size: 5, order: 1 }} md={{ order: 2 }} className="align-self-center" >
      <div className="text-left">
        <Education />
        <Work />
      </div>
    </Col>
  );
};

export default Experience;
